export default __webpack_public_path__ + "static/media/admin-faq-on.41e7f395.svg";